import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import { NAV_LINKS } from '@/enums/navLinks'
import SessionProvider from '@/providers/SessionProvider'
import { privateRoutesPerRole, publicRoutes } from './routes'
import Protected from './Protected'
import AppLayout from '@/components/layout/AppLayout'
import ErrorPage from '../pages/errorPages/404errorPage'
import Cookies from 'js-cookie'
const username = Cookies.get('username')

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      {/* PUBLIC ROUTES */}
      {publicRoutes.map((route, index) => {
        if (username && (route.path === '/faqs' || route.path === '/contact-us')) {
          console.log('hbahjsbjahbsjasb')
          return null
        } else {
          return <Route key={route.path ?? index} {...route} />
        }
      })}
      {/* PUBLIC ROUTES */}

      {/* PRIVATE ROUTES */}
      <Route element={<SessionProvider />}>
        <Route element={<AppLayout />}>
          <Route path={NAV_LINKS.NOT_FOUND} element={<ErrorPage />} />
          {privateRoutesPerRole.map((route, index) => (
            <Route key={index} element={<Protected roles={route.roles} />}>
              <Route key={route.path ?? index} {...route} />
            </Route>
          ))}
        </Route>
      </Route>
      {/* PRIVATE ROUTES */}

      <Route path={NAV_LINKS.NOT_FOUND} element={<ErrorPage />} />
    </Route>
  )
)
